<template>
  <main class="front-page">
    <h1>
      <svg id="uw_100" viewBox="0 0 570 241" aria-label="100" v-show="null">
        <g>
          <path
            class="st0"
            d="M43.9,82.2L29.3,96.5L0.8,63.9L53.3,8h46.1v225H43.9V82.2z M85.5,222.5v-204H60.4L17.3,63.9L30,78.5l27.8-27.4v171.4H85.5z"
          />
          <polygon
            class="st0"
            points="25.5,59.7 43.5,59.7 41.6,61.6 23.6,61.6 	"
          />
          <polygon
            class="st0"
            points="24.4,67.2 36,67.2 34.1,69.1 26.3,69.1 	"
          />
          <polygon
            class="st0"
            points="32.6,52.2 51,52.2 49.1,54.1 30.8,54.1 	"
          />
          <polygon
            class="st0"
            points="39.8,44.7 58.9,44.7 57,46.6 37.9,46.6 	"
          />
          <polygon
            class="st0"
            points="47.3,37.2 82.1,37.2 82.1,39.1 45.4,39.1 	"
          />
          <polygon
            class="st0"
            points="54.4,29.7 82.1,29.7 82.1,31.6 52.5,31.6 	"
          />
          <polygon
            class="st0"
            points="61.9,22.2 82.1,22.2 82.1,24.1 60,24.1 	"
          />
          <rect x="61.1" y="44.7" class="st0" width="21" height="1.9" />
          <rect x="61.1" y="52.2" class="st0" width="21" height="1.9" />
          <rect x="61.1" y="59.7" class="st0" width="21" height="1.9" />
          <rect x="61.1" y="67.2" class="st0" width="21" height="1.9" />
          <rect x="61.1" y="74.7" class="st0" width="21" height="1.9" />
          <rect x="61.1" y="82.2" class="st0" width="21" height="1.9" />
          <rect x="61.1" y="89.7" class="st0" width="21" height="1.9" />
          <rect x="61.1" y="97.2" class="st0" width="21" height="1.9" />
          <rect x="61.1" y="104.7" class="st0" width="21" height="1.9" />
          <rect x="61.1" y="112.2" class="st0" width="21" height="1.9" />
          <rect x="61.1" y="119.7" class="st0" width="21" height="1.9" />
          <rect x="61.1" y="127.2" class="st0" width="21" height="1.9" />
          <rect x="61.1" y="134.7" class="st0" width="21" height="1.9" />
          <rect x="61.1" y="142.2" class="st0" width="21" height="1.9" />
        </g>
        <g>
          <path
            d="M135.7,97.6c0-54,42.4-97.1,99.4-97.1C292.9,0.5,336,43.6,336,97.6v46.5c0,53.6-43.1,96.4-100.9,96.4
                            c-57,0-99.4-42.8-99.4-96.4V97.6z M235.1,230c49.9,0,87-38.3,87-85.9V97.6c0-48-37.1-86.6-87-86.6c-49.1,0-85.5,38.6-85.5,86.6
                            v46.5C149.6,191.7,186,230,235.1,230z"
          />
          <polygon points="153.4,89.7 173.2,89.7 172.9,91.6 153,91.6 	" />
          <rect x="153" y="97.2" width="19.5" height="1.9" />
          <rect x="153" y="104.7" width="19.5" height="1.9" />
          <rect x="153" y="112.2" width="19.5" height="1.9" />
          <rect x="153" y="119.7" width="19.5" height="1.9" />
          <rect x="153" y="127.2" width="19.5" height="1.9" />
          <rect x="153" y="134.7" width="19.5" height="1.9" />
          <rect x="153" y="142.2" width="19.5" height="1.9" />
          <polygon points="154.5,82.2 174.7,82.2 174,84.1 153.7,84.1 	" />
          <polygon points="156,74.7 177,74.7 176.2,76.6 155.2,76.6 	" />
          <polygon points="158.2,67.2 180.4,67.2 179.2,69.1 157.9,69.1 	" />
          <polygon points="161.2,59.7 186,59.7 184.5,61.6 160.5,61.6 	" />
          <polygon points="165.7,52.2 193.5,52.2 191.2,54.1 164.2,54.1 	" />
          <polygon points="171,44.7 204.4,44.7 201,46.6 169.5,46.6 	" />
          <path
            d="M178.1,37.2h114.8l2.3,1.9h-45c-4.5-0.8-10.1-1.5-15-1.5s-10.5,0.8-15,1.5h-43.9L178.1,37.2z"
          />
          <polygon points="187.5,29.7 283.5,29.7 286.1,31.6 184.9,31.6 	" />
          <path
            d="M175.9,98.7c0-32.3,24-57.4,59.3-57.4c36,0,60,25.1,60,57.4V143c0,32.3-24,56.6-60,56.6c-35.3,0-59.3-24.4-59.3-56.6V98.7z
                             M235.1,189.1c27.8,0,46.1-19.9,46.1-46.1V98.7c0-26.3-18.4-46.9-46.1-46.9c-27,0-45.4,20.6-45.4,46.9V143
                            C189.7,169.2,208.1,189.1,235.1,189.1z"
          />
          <polygon points="200.2,22.2 270.4,22.2 274.5,24.1 196.5,24.1 	" />
          <path
            d="M235.1,14.7c6.4,0,13.1,0.8,18.8,1.9h-37.5C222.4,15.1,228.4,14.7,235.1,14.7z"
          />
          <polygon points="299.6,44.7 301.5,46.6 270,46.6 267,44.7 	" />
          <polygon points="305.2,52.2 306.7,54.1 279.7,54.1 277.1,52.2 	" />
          <polygon points="284.6,59.7 309.7,59.7 310.5,61.6 286.5,61.6 	" />
          <polygon points="289.9,67.2 312.7,67.2 313.5,69.1 291,69.1 	" />
          <polygon points="294,74.7 315.4,74.7 316.1,76.6 294.4,76.6 	" />
          <polygon points="296.2,82.2 317.2,82.2 317.6,84.1 296.6,84.1 	" />
          <polygon points="297.7,89.7 318.4,89.7 318.4,91.6 298.1,91.6 	" />
          <rect x="298.5" y="97.2" width="20.3" height="1.9" />
          <rect x="298.5" y="104.7" width="20.3" height="1.9" />
          <rect x="298.5" y="112.2" width="20.3" height="1.9" />
          <rect x="298.5" y="119.7" width="20.3" height="1.9" />
          <rect x="298.5" y="127.2" width="20.3" height="1.9" />
          <rect x="298.5" y="134.7" width="20.3" height="1.9" />
          <rect x="298.5" y="142.2" width="20.3" height="1.9" />
        </g>
        <g>
          <path
            d="M369.7,97.6c0-54,42.4-97.1,99.4-97.1C526.9,0.5,570,43.6,570,97.6v46.5c0,53.6-43.1,96.4-100.9,96.4c-57,0-99.4-42.8-99.4-96.4V97.6z M469.1,230c49.9,0,87-38.3,87-85.9V97.6c0-48-37.1-86.6-87-86.6c-49.1,0-85.5,38.6-85.5,86.6v46.5C383.6,191.7,420,230,469.1,230z"
          />
          <polygon points="387.4,89.7 407.2,89.7 406.9,91.6 387,91.6 	" />
          <rect x="387" y="97.2" width="19.5" height="1.9" />
          <rect x="387" y="104.7" width="19.5" height="1.9" />
          <rect x="387" y="112.2" width="19.5" height="1.9" />
          <rect x="387" y="119.7" width="19.5" height="1.9" />
          <rect x="387" y="127.2" width="19.5" height="1.9" />
          <rect x="387" y="134.7" width="19.5" height="1.9" />
          <rect x="387" y="142.2" width="19.5" height="1.9" />
          <polygon points="388.5,82.2 408.7,82.2 408,84.1 387.7,84.1 	" />
          <polygon points="390,74.7 411,74.7 410.2,76.6 389.2,76.6 	" />
          <polygon points="392.2,67.2 414.4,67.2 413.2,69.1 391.9,69.1 	" />
          <polygon points="395.2,59.7 420,59.7 418.5,61.6 394.5,61.6 	" />
          <polygon points="399.7,52.2 427.5,52.2 425.2,54.1 398.2,54.1 	" />
          <polygon points="405,44.7 438.4,44.7 435,46.6 403.5,46.6 	" />
          <path
            d="M412.1,37.2h114.8l2.3,1.9h-45c-4.5-0.8-10.1-1.5-15-1.5s-10.5,0.8-15,1.5h-43.9L412.1,37.2z"
          />
          <polygon points="421.5,29.7 517.5,29.7 520.1,31.6 418.9,31.6 	" />
          <path
            d="M409.9,98.7c0-32.3,24-57.4,59.3-57.4c36,0,60,25.1,60,57.4V143c0,32.3-24,56.6-60,56.6c-35.3,0-59.3-24.4-59.3-56.6V98.7zM469.1,189.1c27.8,0,46.1-19.9,46.1-46.1V98.7c0-26.3-18.4-46.9-46.1-46.9c-27,0-45.4,20.6-45.4,46.9V143C423.7,169.2,442.1,189.1,469.1,189.1z"
          />
          <polygon points="434.2,22.2 504.4,22.2 508.5,24.1 430.5,24.1 	" />
          <path
            d="M469.1,14.7c6.4,0,13.1,0.8,18.8,1.9h-37.5C456.4,15.1,462.4,14.7,469.1,14.7z"
          />
          <polygon points="533.6,44.7 535.5,46.6 504,46.6 501,44.7 	" />
          <polygon points="539.2,52.2 540.7,54.1 513.7,54.1 511.1,52.2 	" />
          <polygon points="518.6,59.7 543.7,59.7 544.5,61.6 520.5,61.6 	" />
          <polygon points="523.9,67.2 546.7,67.2 547.5,69.1 525,69.1 	" />
          <polygon points="528,74.7 549.4,74.7 550.1,76.6 528.4,76.6 	" />
          <polygon points="530.2,82.2 551.2,82.2 551.6,84.1 530.6,84.1 	" />
          <polygon points="531.7,89.7 552.4,89.7 552.4,91.6 532.1,91.6 	" />
          <rect x="532.5" y="97.2" width="20.3" height="1.9" />
          <rect x="532.5" y="104.7" width="20.3" height="1.9" />
          <rect x="532.5" y="112.2" width="20.3" height="1.9" />
          <rect x="532.5" y="119.7" width="20.3" height="1.9" />
          <rect x="532.5" y="127.2" width="20.3" height="1.9" />
          <rect x="532.5" y="134.7" width="20.3" height="1.9" />
          <rect x="532.5" y="142.2" width="20.3" height="1.9" />
        </g>
      </svg>
      <div class="acier slogan" :class="type_animation_class" v-if="this.$parent.slogan.uri">
        <a class="slogan-content" :href="this.$parent.slogan.uri" target="_blank">{{ this.$parent.slogan.content }}</a>
      </div>
      <span :class="type_animation_class" v-if="animation && null"></span>
    </h1>
    <form :class="search_form_class" id="front-page-search-form" @submit="submitted">
      <div class="search-wrapper">
        <div class="input-wrapper">
          <input type="text" v-model="query" />
        </div>
        <button type="submit">Szukaj</button>
      </div>
    </form>
    <section class="biograms fp-section"  id="section-biograms">
      <div class="biograms-photos" >
        <router-link :to="`/biogramy`" class="img-link">
          <img src="~@/assets/img/frontpage/biogramy01ok.jpg" alt=""/>
        </router-link>
        <router-link :to="`/biogramy`" class="img-link">
          <img src="~@/assets/img/frontpage/biogramy02ok.jpg" alt=""/>
        </router-link>
      </div>
      <div class="text-wrapper">
        <h2>
          <span class="acier">{{ this.$parent.biograms_count }}</span>
          {{
            polishPlurals(
              "BIOGRAM",
              "BIOGRAMY",
              "BIOGRAMÓW",
              this.$parent.biograms_count
            )
          }}
        </h2>
        <p>{{ this.$parent.biograms_description }}</p>
        <router-link
          :to="`/biogramy`"
          class="arrow-link"
          aria-label="Przejdź do biogramów"
        >
          <svg class="arrow-wrapper" viewBox="0 0 113.7 90">
            <path
              class="arrow"
              d="M113.7,45 98.7,29.9 68.8,0 58.2,10.7 77.4,29.9 77.4,29.9 0,29.9 0,45 Z"
            />
            <path
              class="arrow arrow2"
              d="M0,45 0,60.1 77.4,60.1 77.4,60.1 58.2,79.3 68.8,90 98.7,60.1 113.7,45 Z"
            />
          </svg>
        </router-link>
      </div>
      <svg
        id="b-box1"
        class="animated_box"
        preserveAspectRatio="none"
        viewBox="0 0 1200 700"
        aria-hidden="true"
      >
        <line x1="1200" y1="0" x2="1200" y2="700" />
        <line x1="0" y1="700" x2="0" y2="0" />
      </svg>
      <svg
        id="b-box2"
        class="animated_box"
        preserveAspectRatio="none"
        viewBox="0 0 1200 700"
        aria-hidden="true"
      >
        <line x1="1200" y1="0" x2="0" y2="0" />
        <line x1="0" y1="700" x2="1200" y2="700" />
        <rect data-ignore="true" class="rect" width="1200" height="700" />
      </svg>
      <svg
        id="siatka"
        viewBox="0 0 1920 1080"
        preserveAspectRatio="none"
        aria-hidden="true"
      >
        <g>
          <line x1="151.8" y1="0" x2="1921.9" y2="976.8" />
          <line x1="1920.9" y1="1012.8" x2="1810.9" y2="1078.8" />
          <line x1="-4.1" y1="90.7" x2="1777" y2="1078.7" />
          <line x1="137" y1="0" x2="3" y2="75.9" />
          <line x1="1469.8" y1="0" x2="1923.9" y2="248.9" />
          <line x1="1141.7" y1="0" x2="1919" y2="427" />
          <line x1="1922.9" y1="823.8" x2="1486.9" y2="1078.8" />
          <line x1="1922" y1="640" x2="1142" y2="1079" />
          <line x1="1923" y1="462" x2="818.9" y2="1078.8" />
          <line x1="1922" y1="278" x2="485.3" y2="1079" />
          <line x1="1920" y1="95" x2="145" y2="1079" />
          <line x1="1764" y1="0" x2="-4.4" y2="977.9" />
          <line x1="1441" y1="0" x2="-2.1" y2="791.8" />
          <line x1="1118" y1="0" x2="-4" y2="619" />
          <line x1="794" y1="-2" x2="-4" y2="435" />
          <line x1="472" y1="0" x2="-5" y2="255" />
          <line x1="137" y1="0" x2="3" y2="76" />
          <line x1="1.9" y1="1011.8" x2="120" y2="1078.7" />
          <line x1="3" y1="830" x2="448" y2="1078.7" />
          <line x1="0" y1="642.6" x2="770" y2="1078.7" />
          <line x1="0.9" y1="458.8" x2="1100" y2="1078.7" />
          <line x1="0" y1="271.6" x2="1434" y2="1078.7" />
          <line x1="1793" y1="0" x2="1917.9" y2="63.8" />
          <line x1="810.8" y1="0" x2="1923.9" y2="608.8" />
          <line x1="482.8" y1="0" x2="1921.9" y2="791.8" />
        </g>
      </svg>
    </section>
    <section class="photographs fp-section" id="section-photographs">
      <div class="text-wrapper">
        <h2>
          <span class="acier">{{ this.$parent.photos_count }}</span>
          {{
            polishPlurals(
              "FOTOGRAFIA",
              "FOTOGRAFIE",
              "FOTOGRAFII",
              this.$parent.photos_count
            )
          }}
        </h2>
        <p>{{ this.$parent.photos_description }}</p>
        <router-link :to="`/fotografie`" class="arrow-link">
          <svg
            class="arrow-wrapper"
            viewBox="0 0 113.7 90"
            aria-label="Przejdź do fotografii"
          >
            <path
              class="arrow"
              d="M113.7,45 98.7,29.9 68.8,0 58.2,10.7 77.4,29.9 77.4,29.9 0,29.9 0,45 Z"
            />
            <path
              class="arrow arrow2"
              d="M0,45 0,60.1 77.4,60.1 77.4,60.1 58.2,79.3 68.8,90 98.7,60.1 113.7,45 Z"
            />
          </svg>
        </router-link>
      </div>
      <div class="img-wrapper">
        <svg
          id="blur_rect"
          preserveAspectRatio="none"
          viewBox="0 0 300 300"
          aria-hidden="true"
        >
          <rect class="rect" data-ignore="true" width="300" height="300" />
          <line
            class="line"
            data-start="0"
            data-duration="100"
            x1="0"
            y1="0"
            x2="300"
            y2="0"
          />
          <line
            class="line"
            data-start="0"
            data-duration="100"
            x1="0"
            y1="300"
            x2="300"
            y2="300"
          />
          <line
            class="line"
            data-start="100"
            data-duration="100"
            x1="0"
            y1="0"
            x2="0"
            y2="300"
          />
          <line
            class="line"
            data-start="100"
            data-duration="100"
            x1="300"
            y1="0"
            x2="300"
            y2="300"
          />
        </svg>
        <router-link :to="`/fotografie`" class="img-link">
          <img src="~@/assets/img/frontpage/fotografieok.jpg" alt=""/>
        </router-link>
      </div>
    </section>
    <section class="documents fp-section" id="section-documents">
      <svg id="doc-lines" viewBox="0 0 1923.8 423.9" aria-hidden="true">
        <line class="st5" x1="1619" y1="423.9" x2="1619" y2="55.1" />
        <line class="st2" x1="330.5" y1="423.9" x2="330.5" y2="3.6" />
        <line class="st6" x1="1772.5" y1="423.9" x2="1772.5" y2="4.1" />
        <line class="st1" x1="194.5" y1="423.9" x2="194.5" y2="3.6" />
        <line class="st2" x1="717.5" y1="423.9" x2="717.5" y2="3.6" />
        <line class="st4" x1="1026" y1="423.9" x2="1026" y2="55.6" />
        <line class="st0" x1="41.5" y1="423.9" x2="41.5" y2="0.6" />
        <line class="st6" x1="1875.5" y1="423.9" x2="1875.5" y2="4.1" />
        <line class="st3" x1="611.5" y1="423.9" x2="611.5" y2="-0.4" />
        <line class="st7" x1="1292.4" y1="423.9" x2="1292.4" y2="3" />
      </svg>
      <div class="wrapper documents-wrapper">
        <div class="documents-photos">
          <router-link :to="`/dokumenty`" class="img-link">
            <img src="~@/assets/img/frontpage/dokumenty01ok.jpg" alt=""/>
          </router-link>
          <router-link :to="`/dokumenty`" class="img-link">
            <img src="~@/assets/img/frontpage/dokumenty02ok.jpg" alt=""/>
          </router-link>
        </div>
        <div class="text-wrapper">
          <h2>
            <span class="acier">{{ this.$parent.documents_count }}</span>
            {{
              polishPlurals(
                "DOKUMENT",
                "DOKUMENTY",
                "DOKUMENTÓW",
                this.$parent.documents_count
              )
            }}
          </h2>
          <p>{{ this.$parent.documents_description }}</p>
          <router-link
            :to="`/dokumenty`"
            class="arrow-link"
            aria-label="Przejdź do dokumentów"
          >
            <svg class="arrow-wrapper" viewBox="0 0 113.7 90">
              <path
                class="arrow"
                d="M113.7,45 98.7,29.9 68.8,0 58.2,10.7 77.4,29.9 77.4,29.9 0,29.9 0,45 Z"
              />
              <path
                class="arrow arrow2"
                d="M0,45 0,60.1 77.4,60.1 77.4,60.1 58.2,79.3 68.8,90 98.7,60.1 113.7,45 Z"
              />
            </svg>
          </router-link>
        </div>
      </div>
    </section>
    <section class="showpieces fp-section">
      <div class="text-wrapper">
        <h2>
          <span class="acier">{{ this.$parent.showpieces_count }}</span>
          {{
            polishPlurals(
              "EKSPONAT",
              "EKSPONATY",
              "EKSPONATÓW",
              this.$parent.showpieces_count
            )
          }}
        </h2>
        <p>{{ this.$parent.showpieces_description }}</p>
        <router-link :to="`/eksponaty`" class="arrow-link">
          <svg
            class="arrow-wrapper"
            viewBox="0 0 113.7 90"
            aria-label="Przejdź do eksponatów"
          >
            <path
              class="arrow"
              d="M113.7,45 98.7,29.9 68.8,0 58.2,10.7 77.4,29.9 77.4,29.9 0,29.9 0,45 Z"
            />
            <path
              class="arrow arrow2"
              d="M0,45 0,60.1 77.4,60.1 77.4,60.1 58.2,79.3 68.8,90 98.7,60.1 113.7,45 Z"
            />
          </svg>
        </router-link>
      </div>
      <div class="img-wrapper">
        <svg
          id="blur_rect"
          preserveAspectRatio="none"
          viewBox="0 0 300 300"
          aria-hidden="true"
        >
          <rect class="rect" data-ignore="true" width="300" height="300" />
          <line
            class="line"
            data-start="0"
            data-duration="100"
            x1="0"
            y1="0"
            x2="300"
            y2="0"
          />
          <line
            class="line"
            data-start="0"
            data-duration="100"
            x1="0"
            y1="300"
            x2="300"
            y2="300"
          />
          <line
            class="line"
            data-start="100"
            data-duration="100"
            x1="0"
            y1="0"
            x2="0"
            y2="300"
          />
          <line
            class="line"
            data-start="100"
            data-duration="100"
            x1="300"
            y1="0"
            x2="300"
            y2="300"
          />
        </svg>
        <router-link :to="`/eksponaty`" class="img-link">
          <img src="~@/assets/img/eksponat.jpg" alt=""/>
        </router-link>
      </div>
    </section>
    <section class="recordings fp-section">
      <div class="recordings-photos">
        <router-link :to="`/nagrania`" class="img-link sample-class">
          <img src="~@/assets/img/frontpage/recordings.jpg" alt=""/>
        </router-link>
      </div>
      <div class="text-wrapper">
        <h2>
          <span class="acier">{{ this.$parent.recordings_count }}</span>
          {{
            polishPlurals(
              "NAGRANIE",
              "NAGRANIA",
              "NAGRAŃ",
              this.$parent.recordings_count
            )
          }}
        </h2>
        <p>{{ this.$parent.recordings_description }}</p>
        <router-link
          :to="`/nagrania`"
          class="arrow-link"
          aria-label="Przejdź do nagrań"
        >
          <svg class="arrow-wrapper" viewBox="0 0 113.7 90">
            <path
              class="arrow"
              d="M113.7,45 98.7,29.9 68.8,0 58.2,10.7 77.4,29.9 77.4,29.9 0,29.9 0,45 Z"
            />
            <path
              class="arrow arrow2"
              d="M0,45 0,60.1 77.4,60.1 77.4,60.1 58.2,79.3 68.8,90 98.7,60.1 113.7,45 Z"
            />
          </svg>
        </router-link>
      </div>
      <svg
        id="b-box3"
        class="animated_box"
        preserveAspectRatio="none"
        viewBox="0 0 1200 700"
        aria-hidden="true"
      >
        <line x1="1200" y1="0" x2="1200" y2="700" />
        <line x1="0" y1="700" x2="0" y2="0" />
      </svg>
      <svg
        id="b-box4"
        class="animated_box"
        preserveAspectRatio="none"
        viewBox="0 0 1200 700"
        aria-hidden="true"
      >
        <line x1="1200" y1="0" x2="0" y2="0" />
        <line x1="0" y1="700" x2="1200" y2="700" />
        <rect data-ignore="true" class="rect" width="1200" height="700" />
      </svg>
      <svg data-v-c2865498="" id="siatka2" viewBox="0 0 1920 1080" preserveAspectRatio="none" aria-hidden="true"><g data-v-c2865498=""><line data-v-c2865498="" x1="151.8" y1="0" x2="1921.9" y2="976.8"></line> <line data-v-c2865498="" x1="1920.9" y1="1012.8" x2="1810.9" y2="1078.8"></line> <line data-v-c2865498="" x1="-4.1" y1="90.7" x2="1777" y2="1078.7"></line> <line data-v-c2865498="" x1="137" y1="0" x2="3" y2="75.9"></line> <line data-v-c2865498="" x1="1469.8" y1="0" x2="1923.9" y2="248.9"></line> <line data-v-c2865498="" x1="1141.7" y1="0" x2="1919" y2="427"></line> <line data-v-c2865498="" x1="1922.9" y1="823.8" x2="1486.9" y2="1078.8"></line> <line data-v-c2865498="" x1="1922" y1="640" x2="1142" y2="1079"></line> <line data-v-c2865498="" x1="1923" y1="462" x2="818.9" y2="1078.8"></line> <line data-v-c2865498="" x1="1922" y1="278" x2="485.3" y2="1079"></line> <line data-v-c2865498="" x1="1920" y1="95" x2="145" y2="1079"></line> <line data-v-c2865498="" x1="1764" y1="0" x2="-4.4" y2="977.9"></line> <line data-v-c2865498="" x1="1441" y1="0" x2="-2.1" y2="791.8"></line> <line data-v-c2865498="" x1="1118" y1="0" x2="-4" y2="619"></line> <line data-v-c2865498="" x1="794" y1="-2" x2="-4" y2="435"></line> <line data-v-c2865498="" x1="472" y1="0" x2="-5" y2="255"></line> <line data-v-c2865498="" x1="137" y1="0" x2="3" y2="76"></line> <line data-v-c2865498="" x1="1.9" y1="1011.8" x2="120" y2="1078.7"></line> <line data-v-c2865498="" x1="3" y1="830" x2="448" y2="1078.7"></line> <line data-v-c2865498="" x1="0" y1="642.6" x2="770" y2="1078.7"></line> <line data-v-c2865498="" x1="0.9" y1="458.8" x2="1100" y2="1078.7"></line> <line data-v-c2865498="" x1="0" y1="271.6" x2="1434" y2="1078.7"></line> <line data-v-c2865498="" x1="1793" y1="0" x2="1917.9" y2="63.8"></line> <line data-v-c2865498="" x1="810.8" y1="0" x2="1923.9" y2="608.8"></line> <line data-v-c2865498="" x1="482.8" y1="0" x2="1921.9" y2="791.8"></line></g></svg>
    </section>
    
    

  </main>
</template>

<script>
export default {
  name: "IndexContent",
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      site: Array,
      query: null,
      type_animation_class: "type-animation",
      search_form_class: "search-form",
      animation: this.checkAnimation(),
      key: Math.random()
    };
  },
  methods: {
    cleanView: function() {
      this.key = Math.random();
    },
    submitted() {
      this.$router.push({ name: "Search", params: { query: this.query } });
    },
  },
  mounted: function () {
    if (!this.animation || window.innerWidth <= 768) {
      this.search_form_class = this.search_form_class + " shown";
    }
    window.addEventListener("resize", this.cleanView);
  },
};
</script>

<style scoped>

.recordings {
}

.front-page h1 {
  margin-bottom: 2.125rem;
}

.fp-section {
  margin-bottom: 10vh;
}

.front-page h1 .type-animation {
  font-size: 2.3rem;
}

@media (max-width: 1350px) {
  .front-page h1 .type-animation {
    font-size: 1.9rem;
  }
}

@media (max-width: 768px) {
  .front-page h1 .type-animation {
    font-size: 1.5rem;
  }
}

.documents .text-wrapper {
  align-self: flex-start;
}

/* mobile fixes */

@media (max-width: 360px) {
  .fp-section {
    flex-direction: column;
  }

  .text-wrapper {
    width: 100%;
  }

  .text-wrapper p,
  .text-wrapper h2 {
    width: 100%;
    opacity: 1;
  }

  #doc-lines {
    display: none;
  }

  .documents .wrapper {
    flex-direction: column-reverse;
  }

  .photographs {
    margin-top: auto !important;
}

}

@media (max-width: 768px) {
  .text-wrapper p,
  .text-wrapper h2 {
    width: 100%;
    opacity: 1;
  }

  .documents .text-wrapper {
    width: 100%;
}

.documents .img-link:nth-of-type(2) {
    display: none;
}

.photographs {
    margin-top: 10em;
}


}
.recordings img {
width: 45.625rem;
}

.front-page {
  margin-top: 5.5rem;
}

.slogan {
    border: 1px #c63 solid;
    border-right: 0px;
    border-left: 0px;
    padding: 1rem;
    width: 100%;
    text-align: left;
}

.slogan-content {
  width: 90% !important;
  white-space: normal;
  line-height: 1.5em;
}


</style>



// WEBPACK FOOTER //
// src/components/Index/IndexContent.vue